import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {filter, map} from "rxjs/operators";
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-mandat-register',
    templateUrl: './mandat-register.component.html',
    styleUrls: ['./mandat-register.component.css'],
    imports: [MatProgressSpinner]
})
export class MandatRegisterComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);
  private router = inject(Router);


  private apiUrl = environment.apiUrl;

  ngOnInit(): void {
    this.route.queryParams
      .subscribe((params: Params) => {
        const code = String(params.code);
        this.http.post(this.apiUrl + '/user/validate/code', code, {observe: 'response', responseType: 'text'})
          .pipe(
            filter((res: HttpResponse<string>) => res.ok),
            map((res: HttpResponse<string>) => res.body)
          ).subscribe((json: string) => {
            /* eslint @typescript-eslint/no-unsafe-member-access: 0 */
            /* eslint @typescript-eslint/no-unsafe-assignment: 0 */
            const jsonObject = JSON.parse(json);
            localStorage.setItem('accessToken', String(jsonObject.token));
            localStorage.setItem('tiers', String(jsonObject.tiers));
            localStorage.setItem('activated', 'false');

            this.router.navigate(['mandat']);
          },
          (error) => {
            if (error === 'ERR_VALIDATE_EJ_NOT_ACTIVE') {
              this.router.navigate(['mandat/inactived']);
            }
            else if (error === 'ERR_ALREADY_SIGNED_MANDAT') {
              localStorage.setItem('activated', 'true');
              this.router.navigate(['mandat/uncompleted']);
            }
            else if (error === 'ERR_ALREADY_SIGNED_MANDAT_NEW_ACCOUNT') {
              localStorage.setItem('activated', 'false');
              this.router.navigate(['mandat/uncompleted']);
            }
            else {
              this.router.navigate(['mandat/error']);
            }
          });
      });
  }

}
